import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

/** Requester only. A day that already started cannot be cancelled (`DayAlreadyStarted`). */
export function useCancelTimeOffRequestDay() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({ requestId, date }: { requestId: string; date: string }) =>
      timeOffService.cancelRequestDay(requestId, date),
    onSuccess: (_data, { requestId }) => {
      queryClient.invalidateQueries({ queryKey: ['time-off', 'me', 'requests', orgId] });
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.myBalance(orgId) });
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.request(orgId, requestId) });
    },
  });
}
